import BackupsPage, { backupsQuery } from "@app/pages/data-health/backups-page";
import type { backupsPage_Query } from "@app/queries/backupsPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/data-health_/backups")({
  // network-only: arriving here straight after pressing "Back up everything"
  // must show the snapshot just taken, not a store snapshot from before it.
  loader: () =>
    loadQuery<backupsPage_Query>(environment, backupsQuery, {}, { fetchPolicy: "network-only" }),
  head: () => pageHead("Config backups"),
  component: BackupsRoute,
});

function BackupsRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary fallback={<div className="p-6 text-red-500">Error loading backups</div>}>
      <Suspense fallback={<div className="p-6 text-gray-500">Loading backups…</div>}>
        <BackupsPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
